module.exports = __webpack_public_path__ + "static/media/mujer-1.8e2b2acd.png";